import { ReactNode } from 'react'
import { Layout as AntLayout, Menu, Dropdown, Avatar } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import {
  UserOutlined,
  LogoutOutlined,
  FileTextOutlined,
  HomeOutlined,
  PlusOutlined,
  CheckCircleOutlined
} from '@ant-design/icons'

const { Header, Content, Sider } = AntLayout

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ]

  const teacherMenuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: '仪表盘',
      onClick: () => navigate('/')
    },
    {
      key: '/assignments',
      icon: <FileTextOutlined />,
      label: '题目管理',
      onClick: () => navigate('/assignments')
    },
    {
      key: '/assignments/create',
      icon: <PlusOutlined />,
      label: '创建题目',
      onClick: () => navigate('/assignments/create')
    },
    {
      key: '/submissions',
      icon: <CheckCircleOutlined />,
      label: '学生成绩',
      onClick: () => navigate('/submissions')
    }
  ]

  const studentMenuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: '仪表盘',
      onClick: () => navigate('/')
    },
    {
      key: '/assignments',
      icon: <FileTextOutlined />,
      label: '我的作业',
      onClick: () => navigate('/assignments')
    }
  ]

  const menuItems = user?.role === 'teacher' ? teacherMenuItems : studentMenuItems

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider width={200} style={{ background: '#fff' }}>
        <div style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #f0f0f0'
        }}>
          <h2 style={{ margin: 0, color: '#1890ff' }}>Excel实训平台</h2>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <AntLayout>
        <Header style={{
          padding: '0 24px',
          background: '#fff',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}>
          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
              <Avatar icon={<UserOutlined />} />
              <span>{user?.name}</span>
            </div>
          </Dropdown>
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  )
}
